<nb-card>
  <nb-card-header>
    Báo vi phạm
    <button
      class="cancel"
      nbButton
      outline
      status="info"
      size="small"
      (click)="cancel()"
    >
      <nb-icon icon="close-outline"></nb-icon>
    </button>
  </nb-card-header>
  <nb-card-body>
    <form [formGroup]="diaForm">
      <div class="form-group">
        <nb-select
          outline
          fullWidth
          shape="round"
          [status]="value <= 3 ? 'info' : value <= 6 ? 'warning' : 'danger'"
          size="small"
          placeholder="Chọn lý do"
          formControlName="value"
          (selectedChange)="selectedReason($event)"
        >
          <nb-option *ngFor="let item of reasons" [value]="item.value">
            {{ item.reason }}</nb-option
          >
        </nb-select>
      </div>

      <div *ngIf="value == -1" class="form-group">
        <input
          nbInput
          fullWidth
          formControlName="reason"
          placeholder="Nhập lý do khác"
          class="form-control"
          [ngClass]="{
            'form-control-danger':
              diaForm.invalid && (diaForm.dirty || diaForm.touched)
          }"
          [(ngModel)]="reasonElse"
        />
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <button
      type="submit"
      nbButton
      status="primary"
      (click)="submit()"
      [disabled]="submitted || value == 0 || (value == -1 && !diaForm.valid)"
      [class.btn-pulse]="submitted"
    >
      Xác nhận
    </button>
  </nb-card-footer>
</nb-card>
